interface CategoryCssClassMap {
    [key: number]: string;
}

interface CategoryLabelMap {
    [key: number]: string;
}
export const categoryCssClassMap: CategoryCssClassMap = {
    39: 'life-sciences',
    40: 'life-sciences',
    41: 'life-sciences',
    42: 'manufacturing-process',
    43: 'manufacturing-process',
    44: 'manufacturing-process',
    45: 'energy-environment',
    46: 'energy-environment',
    47: 'energy-environment',
    48: 'digital-world',
    49: 'digital-world',
    50: 'digital-world',
    0: 'digital-world',
    1: 'digital-world'
};
export const categoryLabelMap: CategoryLabelMap = {
    39: 'Life Sciences',
    40: 'Life Sciences',
    41: 'Life Sciences',
    42: 'Fertigungsprozesse und Materialien',
    43: 'Fertigungsprozesse und Materialien',
    44: 'Fertigungsprozesse und Materialien',
    45: 'Energie und Umwelt',
    46: 'Energie und Umwelt',
    47: 'Energie und Umwelt',
    48: 'Digitale Welt',
    49: 'Digitale Welt',
    50: 'Digitale Welt',
    0: 'Digitale Welt',
    1: 'Digitale Welt'
};
export const transformWrapperConfig = {
    // wheel: { step: 0.03 },
    wheel: { wheelDisabled: true },
    pinch: { step: 0.01 },
    doubleClick: { step: 0.5 },
    zoomAnimation: { size: 1 },
    initialPositionX: 0,
    minScale: 1,
    maxScale: 4,
    centerOnInit: true,
    disablePadding: true,
    limitToBounds: true,
    alignmentAnimation: { sizeX: 0, sizeY: 0, animationType: 'easeInQuad' as const },
    centerZoomedOut: true,
};